<template>
    <!-- ViewTicketTableColumn -->

    <el-table-column
        v-if="'Selection' == prop"
        type="selection"
        width="35"/>

    <el-table-column
        v-else-if="'TicketMark' == prop"
        label="关注"
        align="center"
        width="60">
        <template slot-scope="scope">
            <TicketMark :ticketNo="scope.row.orderId"/>
        </template>
    </el-table-column>

    <!-- 非 wide 不展示 编号 -->
    <el-table-column
        v-else-if="'TicketNo_Share' == prop"
        label="编号"
        align="center"
        :width="isWide() ? 200 : 50">
        <template slot-scope="scope">
            <span class="ticket_no_span" :title="scope.row.orderId">{{scope.row.orderId}}</span>
            <TicketShare v-if="isWide()" :ticket="scope.row" />
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'TicketNo' == prop"
        label="编号"
        align="center"
        width="200">
        <template slot-scope="scope">
            <span>{{scope.row.orderId}}</span>
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'TicketStatus' == prop"
        label="状态"
        align="center"
        width="80">
        <template slot-scope="scope">
            <!-- {"name":"待受理","value":2},{"name":"处理中","value":3},{"name":"已解决","value":5},{"name":"已关闭","value":6} -->
            <span class="ticket_status_2" v-if="scope.row.orderStatus == 2">{{ ticketStatusIntToString(scope.row.orderStatus) }}</span>
            <span class="ticket_status_3" v-else-if="scope.row.orderStatus == 3">{{ ticketStatusIntToString(scope.row.orderStatus) }}</span>
            <span class="ticket_status_5" v-else-if="scope.row.orderStatus == 5">{{ ticketStatusIntToString(scope.row.orderStatus) }}</span>
            <span class="ticket_status_6" v-else-if="scope.row.orderStatus == 6">{{ ticketStatusIntToString(scope.row.orderStatus) }}</span>
            <span v-else>{{ ticketStatusIntToString(scope.row.orderStatus) }}</span>
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'TicketTitle_ShareIfWide_Tag' == prop"
        label="标题"
        align="left"
        sortable='custom'
        prop="order_title">
        <template slot-scope="scope">
            <TicketTitle :ticketTitle="scope.row.orderTitle" :ticketNo="scope.row.orderId"/>
            <TicketShare v-if="!isWide()" :ticket="scope.row" />
            <TicketTag :ticketNo="scope.row.orderId"/>
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'TicketTitle' == prop"
        label="标题"
        align="left"
        sortable='custom'
        prop="order_title">
        <template slot-scope="scope">
            <TicketTitle :ticketTitle="scope.row.orderTitle" :ticketNo="scope.row.orderId"/>
        </template>
    </el-table-column>

    <el-table-column 
        v-else-if="'TicketPriority' == prop"
        label="优先级"
        align="center"
        sortable='custom'
        prop="order_priority"
        width="100">
        <template slot-scope="scope"> {{ _getPriorityName(scope.row.orderPriority) }} </template>
    </el-table-column>

    <el-table-column 
        v-else-if="'TicketType' == prop"
        label="类型"
        align="center"
        sortable='custom'
        prop="order_type"
        width="105">
        <template slot-scope="scope">
            <TicketType :id="scope.row.orderType"/>
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'CreatorUser' == prop"
        label="创建人"
        align="center"
        sortable='custom'
        prop="creator_id"
        width="115">
        <template slot-scope="scope">
            <TicketUser :ticketNo="scope.row.orderId"
                :userId="scope.row.creatorId"/>
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'DealUser' == prop"
        label="处理人"
        align="center"
        sortable='custom'
        prop="deal_user_id"
        width="100">
        <template slot-scope="scope">
            <TicketUser :ticketNo="scope.row.orderId"
                :userId="scope.row.dealUserId"/>
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'CreatedAt' == prop"
        label="创建于"
        align="center"
        width="110"
        sortable='custom'
        prop="create_time">
        <template slot-scope="scope">
            <span :title="scope.row.createdAt">{{ scope.row.createdAt | ticketTime }}</span>
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'UpdatedAt' == prop"
        label="更新于"
        align="center"
        width="110"
        sortable='custom'
        prop="update_time">
        <template slot-scope="scope">
            <span :title="scope.row.updatedAt">{{ scope.row.updatedAt | ticketTime }}</span>
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'Operation' == prop"
        label="操作"
        align="center"
        width="60"
        fixed="right">
        <template slot-scope="scope">
            <a v-if="scope.row.orderStatus == 2" href="javascript:;"
                @click="dealOrder(scope.row.orderId, scope.row.dealUserId, scope.row.orderStatus, scope.row.orderSuperType)">受理</a>
            <a v-else-if="scope.row.orderStatus == 5" href="javascript:;"
                @click="closeOrder(scope.row.orderId)">关闭</a>
            <a v-else :href="'/ticket/t/'+scope.row.orderId">查看</a>
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'CustomerShop' == prop"
        label="客服店铺">
        <template slot-scope="scope">
            {{prop}} {{scope.row.orderId}} {{scope.row.callId}}
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'PhoneAudio' == prop"
        label="通话录音">
        <template slot-scope="scope">
            {{prop}} {{scope.row.orderId}} {{scope.row.callId}}
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'PhoneLine' == prop"
        label="线路信息">
        <template slot-scope="scope">
            {{prop}} {{scope.row.orderId}} {{scope.row.callId}}
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'TargetNumber' == prop"
        label="被叫号码">
        <template slot-scope="scope">
            {{prop}} {{scope.row.orderId}} {{scope.row.callId}}
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'WorkHour' == prop"
        label="工时"
        align="center"
        sortable='custom'
        width="200">
        <template slot-scope="scope">
            <span>{{scope.row.workHour}}</span>
        </template>
    </el-table-column>

    <el-table-column
        v-else-if="'ContentSummary' == prop"
        label="摘要">
        <template slot-scope="scope">
            <span>{{scope.row.contentSummary}}</span>
        </template>
    </el-table-column>

    <el-table-column
        v-else
        :label="prop + ''">
        <template slot-scope="scope">
            {{prop}} {{scope.row.orderId}} {{scope.row.callId}}
        </template>
    </el-table-column>
</template>

<script>
import { ticketStatusIntToString } from '@/assets/utils/TicketStatusUtil';

export default {
    name : 'ViewTicketTableColumn',

    props : ['prop'],

    methods : {
        ticketStatusIntToString : ticketStatusIntToString,

        //受理工单
        dealOrder(orderId, dealUserId, orderStatus, orderSuperType) {
            var _this = this
            this.$confirm('确认要受理该工单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var data = {
                    'orderId': orderId,
                    'dealUserId': dealUserId, 
                    'orderStatus': orderStatus, 
                    'orderSuperType': orderSuperType
                };

                _this.$http.post('/ticket/v2-workOrder/accept', data).then(response => {
                    var result = response.data
                    if(result.status) {
                        window.location.href = '/ticket/t/' + data.orderId
                    } else {
                        this.$alert(result.message)
                    }
                }, response => {
                    this.$alert('网络繁忙，请稍后重试！')
                })
            }).catch(e => {
                console.log("#573 accept error",e);
            });
        },

        //关闭工单
        closeOrder(orderId) {
            var _this = this;

            this.$confirm('确认要关闭该工单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$http.post('/ticket/v2-workOrder/close', {'orderId': orderId}).then(response => {
                    var result = response.data
                    if(result.status) {
                        _message('关闭工单成功');
                        _this.$emit('after-close-ticket');
                    } else {
                        _this.$alert(result.message)
                    }
                }, response => {
                    _this.$alert('网络繁忙，请稍后重试！')
                })
            }).catch(e => {
                console.log("#743 close error", e)
            });
        }
    }
}
</script>

<style scoped>
    .ticket_no_span {
        display: inline-block;
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;
    }
</style>


// WEBPACK FOOTER //
// src/components/ticket/ViewTicketTableColumn.vue